/* =========================================================================
   APLICAR CUPOM COM CAPRICHO — Black Antecipada (21/10/2026, SÓ NA DEV)

   Pedido do Guilherme: "o botãozinho de aplicar cupom, dá um capricho nele, tanto o da
   coleção quanto os de PDP e pop-up... uma animaçãozinha, alguma coisa que indique que
   foi aplicado, e não só aparecer 'aplicado' escrito".

   UM AJUDANTE SÓ para os três lugares (faixa da coleção, cartão da PDP, cartão da gaveta):
     window.tpCupomOk.aplicar(botao, codigo, opcoes)
       1. o rótulo vira três pontinhos pulsando e o botão "afunda" (is-aplicando);
       2. copia o código, chama /discount/CODIGO (ou o `pedido` que o chamador passar);
       3. segura pelo menos 420 ms (senão o "aplicando" pisca e some);
       4. sucesso: o check se DESENHA (traço animado), o botão dá um "pop", um anel coral
          se expande e some, o código dá um pulo, o celular vibra de leve, e um aviso
          desce do topo da tela: "Cupom BLACK25 aplicado" (is-aplicado);
       5. erro de rede: o rótulo vira "Tentar de novo" e o botão volta a aceitar clique.
     window.tpCupomOk.restaurar(botao, codigo, opcoes)
       Ao carregar a página, se este código já foi aplicado nesta sessão
       (sessionStorage tp-cupom-aplicado), o botão já nasce no estado final, sem animação.
     window.tpCupomOk.toast(texto)
       O aviso do topo, para quem quiser usar sozinho.

   O CSS (classes .tp-cok*, .tp-cok-toast) vive em assets/tp-black-tema.css.
   ========================================================================= */
(function () {
  'use strict';
  var CHECK = '<svg class="tp-cok__check" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 10.6l4 4 8-8.4"/></svg>';
  var toastEl = null, toastTimer = 0;

  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'tp-cok-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = CHECK + '<span></span>';
    toastEl.lastChild.textContent = msg;
    toastEl.classList.remove('is-on');
    void toastEl.offsetWidth;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    /* 5 s (eram 2,6 s): clientes mais velhas não conseguiam ler a tempo (Guilherme, 26/10/2026) */
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 5000);
  }

  function vibrar() { try { if (navigator.vibrate) navigator.vibrate(14); } catch (e) {} }

  function pop(el) { if (!el) return; el.classList.remove('tp-cok-pop'); void el.offsetWidth; el.classList.add('tp-cok-pop'); }

  /* Estado final do botão. `quieto` = sem animação (restauração ao carregar). */
  function marcar(btn, o) {
    o = o || {};
    var rot = o.rotulo || btn;
    btn.classList.add('tp-cok');
    btn.classList.remove('is-aplicando');
    btn.classList.toggle('is-quieto', !!o.quieto);
    btn.classList.add('is-aplicado');
    rot.innerHTML = CHECK + '<span>' + (o.textoOk || 'Aplicado') + '</span>';
    if (o.codigo) btn.setAttribute('aria-label', 'Cupom ' + o.codigo + ' aplicado');
    if (!o.quieto) pop(o.codigoEl);
  }

  /* REGRA DO SITE (27/10/2026, Guilherme): "sempre que tiver um botão de aplicar cupom, quando
     clicado, deve sobrescrever QUALQUER OUTRO CUPOM que estivesse aplicado".

     /discount/CODIGO grava o cookie do cupom (SEM seguir o redirecionamento, que baixava a home
     inteira); DEPOIS o /cart/update.js manda só o código novo — o `discount` substitui o conjunto,
     então os outros saem. Antes os dois iam em paralelo e o /discount/, chegando por último, SOMAVA
     o código ao que já estava (e com BLACK25 guardado a Shopify ficava com o BLACK25).

     Depois avisa o tema (cartUpdate): a gaveta e o carrinho se redesenham sem abrir nada. Sem isso
     a tela seguia com o carrinho antigo, e o "+" da gaveta mandava a chave de linha antiga (a
     Shopify troca a chave quando o desconto muda) e dava erro.

     Só dá certo com o código no carrinho (presente, não `applicable`: com o carrinho vazio ou com
     1 peça no BLACK25 ele fica guardado e vale depois). Exceção à regra: o prêmio da roleta soma
     (tp-roleta*.js), por decisão anterior. */
  function gaveta() { var d = document.querySelector('cart-drawer'); return d && typeof d.getSectionsToRender === 'function' ? d : null; }
  /* Gaveta inteira (itens, cupom, desconto, total) a partir das `sections` do /cart/update.js — o mesmo
     que o renderContents do tema faz, sem abrir a gaveta. O cartUpdate sozinho não basta: ele só troca
     a lista de itens, e o cupom e o total ficavam antigos. */
  function redesenharGaveta(sections) {
    var d = gaveta();
    if (!d || !sections) return;
    d.getSectionsToRender().forEach(function (s) {
      var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
      var novo = sections[s.id] && new DOMParser().parseFromString(sections[s.id], 'text/html').querySelector(s.selector || '.shopify-section');
      if (el && novo) el.innerHTML = novo.innerHTML;
    });
    var fundo = d.querySelector('#CartDrawer-Overlay');
    if (fundo) fundo.addEventListener('click', d.close.bind(d));
  }
  function avisarCarrinho(cart) {
    redesenharGaveta(cart && cart.sections);
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') { try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tp-cupom', cartData: cart }); } catch (e) {} }
  }
  function trocar(codigo) {
    var d = gaveta();
    var pedido = { discount: codigo };
    if (d) { pedido.sections = d.getSectionsToRender().map(function (s) { return s.id; }).join(','); pedido.sections_url = window.location.pathname; }
    return fetch('/discount/' + encodeURIComponent(codigo), { credentials: 'same-origin', redirect: 'manual' }).catch(function () {})
      .then(function () {
        return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(pedido) });
      })
      .then(function (r) { if (!r.ok) throw new Error('cupom'); return r.json(); })
      .then(function (cart) {
        avisarCarrinho(cart);
        var tem = (cart.discount_codes || []).some(function (d) { return String(d.code).toUpperCase() === String(codigo).toUpperCase(); });
        if (!tem) throw new Error('cupom');
        return cart;
      });
  }
  function pedidoPadrao(codigo) { return trocar(codigo); }

  /* CUPONS DE 2 PEÇAS (26/10/2026, pedido do Guilherme): BLACK25/BLACK30 só descontam com 2 peças ou mais.
     Com 0 ou 1 peça o cupom fica guardado no carrinho e entra sozinho na 2ª; o botão diz "ativado" e o
     aviso do topo explica, em vez de "aplicado". Brinde de R$ 0 não conta peça (mesma regra da gaveta). */
  var CUPONS_2_PECAS = ['BLACK25', 'BLACK30'];
  function pecasPagas(cart) {
    return ((cart && cart.items) || []).reduce(function (n, i) { return n + (i.original_price > 0 ? i.quantity : 0); }, 0);
  }
  /* Promessa de true quando o código exige 2 peças e o carrinho ainda não tem. */
  function faltaPeca(codigo, cart) {
    if (CUPONS_2_PECAS.indexOf(String(codigo).toUpperCase()) === -1) return Promise.resolve(false);
    var pega = (cart && cart.items) ? Promise.resolve(cart)
      : fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    return pega.then(function (c) { return pecasPagas(c) < 2; }, function () { return false; });
  }

  function aplicar(btn, codigo, o) {
    o = o || {};
    if (!btn || !codigo || btn.classList.contains('is-aplicando')) return Promise.resolve(false);
    var rot = o.rotulo || btn;
    btn.classList.add('tp-cok', 'is-aplicando');
    btn.classList.remove('is-aplicado', 'is-quieto');
    rot.innerHTML = '<span class="tp-cok__dots" aria-label="Aplicando"><i></i><i></i><i></i></span>';
    try { if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(codigo).catch(function () {}); } catch (e) {}
    var inicio = Date.now();
    var pedido;
    try { pedido = o.pedido ? o.pedido() : pedidoPadrao(codigo); }
    catch (e) { pedido = Promise.reject(e); }
    var falta = false;
    return Promise.resolve(pedido)
      .then(function (v) { return faltaPeca(codigo, v).then(function (f) { falta = f; return true; }); }, function () { return false; })
      .then(function (ok) {
        var espera = Math.max(0, 420 - (Date.now() - inicio));
        return new Promise(function (res) { setTimeout(function () { res(ok); }, espera); });
      })
      .then(function (ok) {
        if (!ok) {
          btn.classList.remove('is-aplicando');
          rot.textContent = o.textoErro || 'Tentar de novo';
          return false;
        }
        marcar(btn, { rotulo: rot, textoOk: falta ? 'ativado' : o.textoOk, codigo: codigo, codigoEl: o.codigoEl });
        vibrar();
        try { sessionStorage.setItem('tp-cupom-aplicado', codigo); } catch (e) {}
        if (o.toast !== false) toast(falta ? codigo + ' guardado · vale com 2 peças' : (o.toastTexto || ('Cupom ' + codigo + ' aplicado')));
        return true;
      });
  }

  function restaurar(btn, codigo, o) {
    if (!btn || !codigo) return false;
    var ja = null;
    try { ja = sessionStorage.getItem('tp-cupom-aplicado'); } catch (e) {}
    if (ja !== codigo) return false;
    o = o || {};
    marcar(btn, { rotulo: o.rotulo, textoOk: o.textoOk, codigo: codigo, quieto: true });
    faltaPeca(codigo).then(function (f) { if (f) marcar(btn, { rotulo: o.rotulo, textoOk: 'ativado', codigo: codigo, quieto: true }); });
    return true;
  }

  window.tpCupomOk = { aplicar: aplicar, marcar: marcar, restaurar: restaurar, toast: toast, trocar: trocar };
})();
